module.exports = "/_next/static/images/5faffe923ce385b1ec670c8486378d35-xpeer-xs.jpg.webp";